export default "__VITE_ASSET__RDYJmMkw__ 400w, __VITE_ASSET__CCs_5zNU__ 800w, __VITE_ASSET__BDlN3LUO__ 1024w";